import { getTopWindow } from '@/js/libs/framework/top-window';
export const DEFAULT_KEY = 'adnz_debug';
export const isDebug = (key = DEFAULT_KEY) => {
    try {
        const top = getTopWindow();
        try {
            const storageValue = !!top.localStorage.getItem(key);
            if (storageValue) {
                return true;
            }
        }
        catch (err) {
            // it's ok
        }
        const searchValue = new URLSearchParams(top.location.search).get(key);
        return !!searchValue;
    }
    catch (err) {
        return false;
    }
};
